import { i18n } from "discourse-i18n";

<template>
  <@outletArgs.form.Section
    @title={{i18n "category.waze_require_edit_reason_heading"}}
    class="category-custom-settings-outlet waze-require-edit-reason-settings"
  >
    <@outletArgs.form.Object @name="custom_fields" as |object|>
      <object.Field
        @name="waze_require_edit_reason"
        @title={{i18n "category.waze_require_edit_reason_label"}}
        @format="max"
        @type="checkbox"
        as |field|
      >
        <field.Control />
      </object.Field>
    </@outletArgs.form.Object>
  </@outletArgs.form.Section>
</template>
